'use strict';

require('./string');
require('./number');
require('./array');
require('./enumerable');
require('./object');
require('./date');
require('./range');
require('./function');
require('./regexp');

module.exports = require('sugar-core');


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/index.js
// module id = 579
// module chunks = 0